const imageBaseUrl = String(process.env.REACT_APP_IMAGE_URL || '').replace(/\/+$/, '');

export const getAttachmentUrl = (attachment) =>
  `${imageBaseUrl}/${String(attachment || '').replace(/^\/+/, '')}`;

export const getAttachmentName = (attachment) => {
  const segments = String(attachment || '').split(/[\\/]/);
  return segments[segments.length - 1] || 'attachment';
};

export const isPdfAttachment = (attachment) => /\.pdf(?:$|[?#])/i.test(String(attachment || ''));
